import { getVertexTypeInNetwork, TYPE_VERTEX } from '@/shared/constants/ds-constants';

export class BinaryExpression {
  type: string = null; // and/or
  left: any = null; //string/binaryExpression
  right: any = null; //string/binaryExpression
}
